import * as React from "react";
import {
  Box,
  Tabs,
  Tab,
  Menu,
  MenuItem,
  Container,
  IconButton,
  Popover,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import Beranda from "./components/Beranda";
import Events from "./components/Events";
import Urban from "./components/Urban";
import Feedback from "./components/Feedback";
import Nonurban from "./components/Nonurban";
import Mcp from "./components/Mcp";
import Cps from "./components/Cons";
import Qc from "./components/Qcqa";
import Climate from "./components/Climate";
import GeoDataUtilization from "./components/GeospatialDataUtilization";
import ClarifCons from "./components/ClarifCons";
import Ce from "./components/CapacityEnhancement";
import Multimedia from "./components/PengadaanMultimedia";
import Sarana from "./components/PeningkatanSarana";
import GeoClimate from "./components/GeospatialClimateAction"
import PerangkatSistem from "./components/PerangkatSistem"
import ClarifNon from "./components/ClarifNon";
import Risiko from "./components/Risiko";
import Devimaps from "./components/Devimaps";
import Generalisasi from "./components/Generalisasi";
import Pengadaan from "./components/Pengadaan";
import Proyek from "./components/Proyek";
import Perpus from "./components/Perpus";
import Komputer from "./components/Komputer";
import ClarifUrban from "./components/ClarifUrban";
import ClarifGeneralisasi from "./components/ClarifGeneralisasi";
import SampleAccessData from "./components/SampleAccessData";
import SampleAccessDataDua from "./components/SampleAccessDataDua";
import SampleAccessDataTiga from "./components/SampleAccessDataTiga";
import Faq from "./components/Faq";

function LinkTab(props) {
  const { onClick, ...rest } = props;
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
        if (onClick) {
          onClick(event);
        }
      }}
      {...rest}
    />
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const tabs = [
  { label: "Home", path: "#/", component: <Beranda /> },
  {
    label: "Projects",
    submenu: [
      { label: "URBAN BASE MAPS", path: "#/urban", component: <Urban /> },
      { label: "NON-URBAN BASE MAPS", path: "#/nonurban", component: <Nonurban /> },
      { label: "QC/QA BASE MAPS", path: "#/qc", component: <Qc /> },
      { label: "PMC", path: "#/pmc", component: <Mcp /> },
      { label: "GENERALISASI", path: "#/generalisasi", component: <Generalisasi /> },
      {
        label: "CONSULTANT SPECIALIST",
        submenu: [
          
          { label: "PROCUREMENT SPECIALIST (5.2)", path: "#/cps", component: <Cps /> },
          { label: "CLIMATE CHANGE POLICY EXPERT (4.2.b)", path: "#/Climate-Change", component: <Climate /> },
          { label: "GEOSPATIAL DATA UTILIZATION POLICY EXPERT (4.2.b)", path: "#/GeoDataUtilization", component: <GeoDataUtilization /> },
          { label: "PROCUREMENT SPECIALIST", path: "#/procurement-specialist", component: <Pengadaan /> },
          { label: "RISK MANAGEMENT", path: "#/risk-management", component: <Risiko /> },
          { label: "PROJECT MANAGEMENT", path: "#/project-management", component: <Proyek /> },
        ],
      },
      { label: "GEOSPATIAL CAPACITY ENHANCEMENT", path: "#/capacity-enhancement", component: <Ce /> },
      { label: "PAKET PENGADAAN PC, LAPTOP, DAN PERALATAN MULTIMEDIA PUSAT PENGEMBANGAN KOMPETENSI", path: "#/pengadaan-multimedia", component: <Multimedia /> },
      { label: "PAKET PENGADAAN SARANA PUSAT PENGEMBANGAN KOMPETENSI", path: "#/peningkatan-sarana", component: <Sarana /> },
      { label: "GEOSPATIAL DATA UTILIZATION PLATFORM FOR CLIMATE ACTION", path: "#/geospatial-platform-for-climate-action", component: <GeoClimate /> },
      { label: "PENGADAAN TAHAP I PERANGKAT SISTEM PRODUKSI PETA TERINTEGRASI", path: "#/perangkat-sistem-produksi-peta-terintegrasi", component: <PerangkatSistem /> },
      { label: "DEVELOPMENT OF INTEGRATED MAP PRODUCTION SYSTEM", path: "#/development-of-integrated-map-production-system", component: <Devimaps /> },
      { label: "PENAMBAHAN KOLEKSI PERPUSTAKAAN", path: "#/penambahan-koleksi-perpustakaan", component: <Perpus /> },
      { label: "PENGADAAN LAPTOP MEDIA PEMBELAJARAN", path: "#/pengadaan-laptop-media-pembelajaran", component: <Komputer /> },
    ],
  },
  
  { label: "Materials", path: "#/Materials", component: <Events /> },
  {
    label: "Clarification",
    submenu: [
      { label: "URBAN BASE MAPS", path: "#/Clarification/Urban", component: <ClarifUrban /> },
      { label: "NON-URBAN BASE MAPS", path: "#/Clarification/Nonurban", component: <ClarifNon /> },
      { label: "CONSULTANT PROCUREMENT SPECIALIST", path: "#/Clarification/cps", component: <ClarifCons /> },
      { label: "GENERALISASI", path: "#/Clarification/Generalisasi", component: <ClarifGeneralisasi /> },
    ],
  },
  { label: "Feedback", path: "#/feedback", component: <Feedback /> },
  { label: "Faq", path: "#/faq", component: <Faq /> },
  {
    label: "Sample Data Access",
    submenu: [
      { label: "URBAN BASE MAPS", path: "#/SampleDataAccess/Urban", component: <SampleAccessData /> },
      { label: "NON-URBAN BASE MAPS", path: "#/SampleDataAccess/NonUrban", component: <SampleAccessDataDua /> },
      { label: "GENERALIZATION", path: "#/SampleDataAccess/Generalization", component: <SampleAccessDataTiga /> },
    ],
  },
];

function App() {
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [submenuItems, setSubmenuItems] = React.useState([]);
  const [currentParentTab, setCurrentParentTab] = React.useState(null);
  const location = useLocation();
  const [nestedSubmenuItems, setNestedSubmenuItems] = React.useState([]);
  const [nestedAnchorEl, setNestedAnchorEl] = React.useState(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = React.useState(null);
  const isMobileMenuOpen = Boolean(mobileMenuAnchor);
  const [clickedMenuItem, setClickedMenuItem] = React.useState(null);
  const [mobileClickedMenuItem, setMobileClickedMenuItem] = React.useState(null);
  const [menuItemPosition, setMenuItemPosition] = React.useState(null);

  const handleTabClick = (event, tabIndex) => {
    const selectedTab = tabs[tabIndex];
    if (selectedTab.submenu) {
      setAnchorEl(event.currentTarget);
      setSubmenuItems(selectedTab.submenu);
      setCurrentParentTab(tabIndex);
      setClickedMenuItem(null); // Reset clicked menu item when opening new level 1 menu
    } else {
      setValue(tabIndex);
      if (selectedTab.external) {
        window.location.href = selectedTab.path;
      } else {
        window.location.hash = selectedTab.path;
      }
    }
  };

  const handleCloseAllMenus = () => {
    setAnchorEl(null);
    setSubmenuItems([]);
    setNestedAnchorEl(null);
    setNestedSubmenuItems([]);
    setClickedMenuItem(null);
    setMobileClickedMenuItem(null);
  };

  const handleSubmenuClick = (item, event) => {
    if (item.submenu) {
      // Get the position of the clicked menu item
      const rect = event.currentTarget.getBoundingClientRect();
      setMenuItemPosition({
        top: rect.top,
        left: rect.left + rect.width, // Position to the right of the menu item
      });
      setClickedMenuItem(item);
      return;
    }
    
    if (item.external) {
      window.open(item.path, "_blank", "noopener,noreferrer");
    } else {
      window.location.hash = item.path;
    }
    handleCloseAllMenus();
  };

  const handleMobileSubmenuClick = (item) => {
    if (item.submenu) {
      setMobileClickedMenuItem(item);
      return;
    }
    
    if (item.external) {
      window.open(item.path, "_blank", "noopener,noreferrer");
    } else {
      window.location.hash = item.path;
    }
    setMobileMenuAnchor(null);
  };

  React.useEffect(() => {
    const path = window.location.hash;
    let foundIndex = tabs.findIndex((tab) => tab.path === path);
    if (foundIndex === -1) {
      tabs.forEach((tab, idx) => {
        if (tab.submenu) {
          tab.submenu.forEach((item) => {
            if (item.path === path) {
              foundIndex = idx;
            } else if (item.submenu) {
              item.submenu.forEach((subitem) => {
                if (subitem.path === path) {
                  foundIndex = idx;
                }
              });
            }
          });
        }
      });
    }
    setValue(foundIndex !== -1 ? foundIndex : 0);
  }, [location]);

  return (
    <>
      <Container 
        maxWidth={false}
        style={{ 
          display: "flex", 
          height: "10vh", 
          justifyContent: "space-between", 
          alignItems: "center",
          padding: "0 16px",
        }}
      >
        <div
          style={{ 
            display: "flex", 
            flexDirection: "row", 
            alignItems: "center", 
            cursor: "pointer",
            minWidth: "fit-content",
            marginRight: "16px"
          }}
          onClick={() => (window.location.hash = "#/")}
        >
          <img src="./logobig.png" alt="logo BIG" width="45px" height="51px" />
          <h3 style={{ paddingLeft: "15px", fontSize: "1.1rem", whiteSpace: "nowrap" }}>
            ILASPP-PROCUREMENT
          </h3>
        </div>

        {/* Desktop Tabs */}
        <Box sx={{ 
          display: { xs: "none", md: "flex" }, 
          alignItems: "center",
          flex: 1,
          justifyContent: "flex-end",
          overflow: "hidden"
        }}>
          <Tabs 
            value={value} 
            aria-label="nav tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              maxWidth: "100%",
              minHeight: "56px",
              backgroundColor: 'transparent',
              '& .MuiTabs-flexContainer': {
                gap: '2px',
                alignItems: 'center',
              },
              '& .MuiTab-root': {
                minWidth: '90px',
                maxWidth: '160px',
                fontSize: '0.8rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                padding: '12px 16px',
                minHeight: '56px',
                whiteSpace: 'normal',
                lineHeight: 1.3,
                textAlign: 'center',
                color: '#546e7a',
                borderRadius: '8px 8px 0 0',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                zIndex: 1,
                '&:hover': {
                  backgroundColor: 'rgba(46, 46, 46, 0.06)',
                  color: '#2e2e2e',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                },
                '&.Mui-selected': {
                  backgroundColor: '#2e2e2e',
                  color: '#ffffff',
                  boxShadow: '0 4px 12px rgba(46, 46, 46, 0.3)',
                  transform: 'translateY(-2px)',
                  '&:hover': {
                    backgroundColor: '#1a1a1a',
                    color: '#ffffff',
                  }
                },
                '&:before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                  borderRadius: '8px 8px 0 0',
                  opacity: 0,
                  transition: 'opacity 0.3s ease',
                  zIndex: -1,
                },
                '&.Mui-selected:before': {
                  opacity: 1,
                }
              },
              '& .MuiTabs-scrollButtons': {
                color: '#546e7a',
                borderRadius: '50%',
                margin: '0 4px',
                '&:hover': {
                  backgroundColor: 'rgba(46, 46, 46, 0.08)',
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
              },
              '& .MuiTabs-indicator': {
                display: 'none', // Hide default indicator since we're using custom selected style
              }
            }}
          >
            {tabs.map((tab, index) => (
              <Tooltip key={index} title={tab.label} placement="bottom">
                <LinkTab 
                  label={tab.label} 
                  onClick={(event) => handleTabClick(event, index)}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                />
              </Tooltip>
            ))}
          </Tabs>

          {/* Menu Level 1 */}
          <Menu
            id="submenu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseAllMenus}
            PaperProps={{
              style: {
                maxHeight: '400px',
                width: 'auto',
                minWidth: '280px',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(46, 46, 46, 0.15)',
                marginTop: '8px',
              },
            }}
            MenuListProps={{
              style: {
                padding: '12px 0',
              },
            }}
          >
            {submenuItems.map((item, idx) => (
              <MenuItem 
                key={idx} 
                onClick={(e) => handleSubmenuClick(item, e)}
                sx={{ 
                  position: 'relative',
                  minWidth: '280px',
                  maxWidth: '420px',
                  padding: '14px 20px',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  lineHeight: 1.4,
                  color: '#2e2e2e',
                  margin: '0 8px',
                  borderRadius: '8px',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(46, 46, 46, 0.08)',
                    transform: 'translateX(4px)',
                  }
                }}
              >
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  width: '100%'
                }}>
                  <span style={{ flex: 1, paddingRight: '12px' }}>
                    {item.label}
                  </span>
                  {item.submenu && (
                    <ArrowRightIcon 
                      fontSize="small" 
                      sx={{ 
                        color: '#546e7a',
                        transition: 'transform 0.2s ease',
                        '.MuiMenuItem-root:hover &': {
                          transform: 'translateX(2px)',
                        }
                      }} 
                    />
                  )}
                </Box>
              </MenuItem>
            ))}
          </Menu>

          {/* Menu Level 2 */}
          <Popover
            open={Boolean(clickedMenuItem)}
            onClose={handleCloseAllMenus}
            anchorReference="anchorPosition"
            anchorPosition={menuItemPosition}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              style: {
                maxHeight: '400px',
                width: 'auto',
                minWidth: '280px',
                maxWidth: '420px',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(46, 46, 46, 0.15)',
              },
            }}
            sx={{ 
              '& .MuiPaper-root': {
                marginLeft: '4px',
              }
            }}
          >
            {clickedMenuItem?.submenu?.map((subItem, subIdx) => (
              <MenuItem 
                key={subIdx} 
                onClick={() => {
                  if (subItem.external) {
                    window.open(subItem.path, "_blank", "noopener,noreferrer");
                  } else {
                    window.location.hash = subItem.path;
                  }
                  handleCloseAllMenus();
                }}
                sx={{
                  minWidth: '280px',
                  maxWidth: '420px',
                  padding: '14px 20px',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  lineHeight: 1.4,
                  color: '#2e2e2e',
                  margin: '0 8px',
                  borderRadius: '8px',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(46, 46, 46, 0.08)',
                    transform: 'translateX(4px)',
                  }
                }}
              >
                {subItem.label}
              </MenuItem>
            ))}
          </Popover>
        </Box>

        {/* Mobile Hamburger Menu */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={(e) => {
              setMobileMenuAnchor(e.currentTarget);
              setMobileClickedMenuItem(null);
            }}
            sx={{
              color: '#2e2e2e',
              borderRadius: '8px',
              padding: '8px',
              '&:hover': {
                backgroundColor: 'rgba(46, 46, 46, 0.08)',
                transform: 'scale(1.05)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
        <Menu
          id="mobile-menu"
          anchorEl={mobileMenuAnchor}
          open={isMobileMenuOpen}
          onClose={() => {
            setMobileMenuAnchor(null);
            setMobileClickedMenuItem(null);
          }}
          PaperProps={{
            style: {
              maxHeight: '70vh',
              width: '90vw',
              maxWidth: '400px',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(46, 46, 46, 0.15)',
            },
          }}
        >
          {tabs.map((tab, index) =>
            tab.submenu ? (
              <React.Fragment key={index}>
                <MenuItem 
                  onClick={() => {
                    if (tab.path) {
                      window.location.hash = tab.path;
                      setMobileMenuAnchor(null);
                    }
                  }}
                  sx={{ 
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    padding: '16px 20px',
                    borderBottom: '1px solid rgba(46, 46, 46, 0.1)',
                    color: '#2e2e2e',
                    fontSize: '0.9rem',
                    '&:hover': {
                      backgroundColor: 'rgba(46, 46, 46, 0.06)',
                    }
                  }}
                >
                  {tab.label}
                </MenuItem>
                {tab.submenu.map((item, subIdx) =>
                  item.submenu ? (
                    <React.Fragment key={subIdx}>
                      <MenuItem 
                        onClick={() => handleMobileSubmenuClick(item)}
                        sx={{ 
                          pl: 3, 
                          fontWeight: mobileClickedMenuItem === item ? 600 : 400,
                          padding: '12px 32px',
                          fontSize: '0.85rem',
                          color: '#546e7a',
                          backgroundColor: mobileClickedMenuItem === item ? 'rgba(46, 46, 46, 0.06)' : 'transparent',
                          '&:hover': {
                            backgroundColor: 'rgba(46, 46, 46, 0.08)',
                          }
                        }}
                      >
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          width: '100%'
                        }}>
                          <span style={{ flex: 1, paddingRight: '8px' }}>
                            {item.label}
                          </span>
                          <ArrowRightIcon fontSize="small" sx={{ color: '#2e2e2e' }} />
                        </Box>
                      </MenuItem>
                      {mobileClickedMenuItem === item && item.submenu.map((subItem, subSubIdx) => (
                        <MenuItem
                          key={subSubIdx}
                          onClick={() => {
                            if (subItem.external) {
                              window.open(subItem.path, "_blank", "noopener,noreferrer");
                            } else {
                              window.location.hash = subItem.path;
                            }
                            setMobileMenuAnchor(null);
                          }}
                          sx={{ 
                            pl: 6,
                            padding: '10px 48px',
                            fontSize: '0.8rem',
                            color: '#546e7a',
                            backgroundColor: 'rgba(46, 46, 46, 0.03)',
                            '&:hover': {
                              backgroundColor: 'rgba(46, 46, 46, 0.08)',
                            }
                          }}
                        >
                          {subItem.label}
                        </MenuItem>
                      ))}
                    </React.Fragment>
                  ) : (
                    <MenuItem
                      key={subIdx}
                      onClick={() => handleMobileSubmenuClick(item)}
                      sx={{ 
                        pl: 3,
                        padding: '12px 32px',
                        fontSize: '0.85rem',
                        color: '#546e7a',
                        '&:hover': {
                          backgroundColor: 'rgba(46, 46, 46, 0.06)',
                        }
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  )
                )}
              </React.Fragment>
            ) : (
              <MenuItem
                key={index}
                onClick={() => {
                  handleTabClick({}, index);
                  setMobileMenuAnchor(null);
                }}
                sx={{
                  padding: '16px 20px',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: '1px solid rgba(46, 46, 46, 0.1)',
                  color: '#2e2e2e',
                  fontSize: '0.9rem',
                  '&:hover': {
                    backgroundColor: 'rgba(46, 46, 46, 0.06)',
                  }
                }}
              >
                {tab.label}
              </MenuItem>
            )
          )}
        </Menu>
      </Container>

      <div style={{ width: "100%", minHeight: "calc(100vh - 150px)" }}>
        {tabs.map((tab, idx) => {
          if (tab.submenu) {
            return tab.submenu.map((item, sidx) => {
              if (item.submenu) {
                return item.submenu.map((subItem, ssidx) =>
                  !subItem.external && window.location.hash === subItem.path ? (
                    <TabPanel key={`${idx}-${sidx}-${ssidx}`} value={value} index={idx}>
                      {subItem.component}
                    </TabPanel>
                  ) : null
                );
              }
              return !item.external && window.location.hash === item.path ? (
                <TabPanel key={`${idx}-${sidx}`} value={value} index={idx}>
                  {item.component}
                </TabPanel>
              ) : null;
            });
          }
          return !tab.external ? (
            <TabPanel key={idx} value={value} index={idx}>
              {tab.component}
            </TabPanel>
          ) : null;
        })}
      </div>

      {/* ====== FOOTER ====== */}
      <div style={{ width: "100%", backgroundColor: "#2e2e2e" }}>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            padding: "30px",
            color: "#fff",
            flexWrap: "wrap",
          }}
        >
          {/* Kontak BIG */}
          <div style={{ flex: "1", minWidth: "250px", paddingRight: "20px" }}>
            <h4>Geospatial Information Agency</h4>
            <p>Jl. Raya Jakarta-Bogor Km. 46, Cibinong 16911, Indonesia</p>
            <p>
              Email: <br />
              pokja.dprwd@big.go.id<br />
              pokja.dapig@big.go.id<br />
              pokja.stig@big.go.id<br />
              pokja.ppkig@big.go.id<br />
              pokja.psdmo@big.go.id
            </p>
            <p>Phone: +62 21 8752062</p>
          </div>

          {/* Link & Sosial Media */}
          <div style={{ flex: "1", minWidth: "250px", paddingLeft: "400px" }}>
            <h4>Links</h4>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>
                <a
                  href="https://www.big.go.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  BIG Website
                </a>
              </li>
              <li>
                <a
                  href="https://www.worldbank.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  World Bank Group
                </a>
              </li>
              <li>
                <a
                  href="https://lpse.big.go.id"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  LPSE BIG
                </a>
              </li>
            </ul>
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
              <a
                href="https://instagram.com/infogeospasial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/24/2111/2111463.png"
                  alt="Instagram"
                />
              </a>
              <a
                href="https://x.com/infogeospasial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/24/5968/5968958.png"
                  alt="X"
                  style={{ filter: "invert(1)" }}
                />
              </a>
            </div>
          </div>
        </div>

     
        <div
          style={{
            textAlign: "center",
            padding: "15px 0",
            borderTop: "1px solid #444",
            color: "#aaa",
            fontSize: "0.9em",
          }}
        >
          &copy; {new Date().getFullYear()} ILASP Project - Badan Informasi Geospasial
          
          
          
        </div>
      </div>
    </>
  );
}

export default App;